export default {
  TABLE: 'table',
  CHARTS: 'charts',
};
